import "./Loading.scss"

export function Loading(): JSX.Element {
  return <div className="spinner" data-testid="loading-spinner" />
}
